module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud_m_gov.591284c545f97ce0aa06b36135888997.svg";